import AppsShow from "../components/apps/Show";

export default [
  { name: 'Apps', path: '/apps', component: AppsShow,  }
]
